import React, {useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import InfoCard from '../../components/info-card/info-card.jsx';
import GallerySlide from '../../components/gallery-slide/gallery-slide.jsx';
import ContactForm from '../../components/contact-form/contact-form.jsx';
import ImageInfo from '../../components/image-info/image-info.jsx';
import InfoBox from '../../components/info-box/info-box.jsx';
import OverlayTextImage from '../../components/overlay-text-image/overlay-text-image.jsx';


import './welcome-wrapper.css';

const WelcomeWrapper = ({data, isMobile}) => {

  const serviceCards = data?.serviceCards?.map((card, index) => {
    return (
      <div className="col-sm-12 col-md-6 col-lg-3" key={index}>
        <InfoCard title={card?.title} text={card?.text}/>
      </div>
    )
  })

  const sideBySideContent = data?.sideBySideContent.map((card, index) => {
    return (
      <div className="margin-top-5 margin-bottom-5 sliding-container" key={index}>
        <ImageInfo 
          title={card.title} 
          text={card.text} 
          image={card.image} 
          isImageOnTheLeft={isMobile || card.isImageOnTheLeft}/>
      </div>
    )
  })

  const footerIcons = data?.footer?.socials.map((icon, index) => {
    if(icon.showIcon){
      return (
        <span key={index}>
          <a href={icon.link} target="_blank" rel="noreferrer" className="default-link">
            <i className={`social-icon fab fa-${icon.icon}`}></i>
          </a>
        </span>
      )
    }
    return ""
  })

  return (
    <div className="welcome-dashboard-wrapper relative-position">
        <Helmet>
            <title>Welcome</title>
            <meta property="og:title" content="Welcome to Pendo Presbyterian Church Home" />
            <meta name="description" content={`Pendo Presbyterian Church Home - ${data?.landingImage?.text}`} />
        </Helmet>
        <div className="home-body relative-position">

          <OverlayTextImage  
            image={data?.landingImage?.image} 
            title={data?.landingImage?.title} 
            slogan={data?.landingImage?.slogan}
            text={data?.landingImage?.text}
            />

          <div className="row margin-bottom-5">
            <InfoBox 
              boxStyleClass="mission-statement-mobile"
              styleClass="mobile-small-block-text" 
              title={data?.mission?.title} text={data?.mission?.text}/>
          </div>
          
          
          {isMobile?  
            <div className="row">
              <InfoBox title={data?.serviceTitle} isTitleOnly={true}/>
            </div> : ""
          }
          
          <div className="cards row">
            {serviceCards}
          </div>
          
          {sideBySideContent}

          <GallerySlide 
            images={data?.imageSlideShow} 
            showThumbnails={true}/>

          <div className="margin-top-5">
            <ContactForm 
              detailsTitle={data?.contactDetails?.title} 
              phone={data?.contactDetails?.phone} 
              additionalNumbers={data?.contactDetails?.additionalNumbers} 
              fax={data?.contactDetails?.fax} 
              email={data?.contactDetails?.email} 
              address={data?.contactDetails?.address} 
              addressLink={data?.contactDetails?.addressLink} 
              hideForm={data?.contactDetails?.hideForm} 
              showWithTwoColumns={data?.contactDetails?.showWithTwoColumns} />
          </div>
        </div>
        <div className='footer full-width margin-top-5'>
          <div className="container center">
            <div>
             {footerIcons}
            </div>
          </div>
          <div className="container center">
            <p>&copy; {data?.footer?.text}</p>
          </div>
        </div>
    </div>
  );

}

export default WelcomeWrapper;
